import { PALETTE as P } from "../../tokens";

/**
 * FoundationsSlider — spectrum between two named poles (0.0–1.0).
 *
 * No numeric display — the value is felt, not read. The thumb rests at
 * center until the user moves it; the container treats the prompt as
 * answered only once `value` becomes a number.
 *
 * Props:
 *   leftLabel  — label at the 0.0 pole
 *   rightLabel — label at the 1.0 pole
 *   onChange   — (float) => void
 *   value      — current value (or undefined before first interaction)
 */
export default function FoundationsSlider({ leftLabel, rightLabel, onChange, value }) {
  const pos = typeof value === "number" ? value : 0.5;
  return (
    <div>
      <input
        type="range"
        min="0"
        max="1"
        step="0.01"
        value={pos}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        style={{
          width: "100%",
          accentColor: P.primary,
          cursor: "pointer",
          height: 28,
        }}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 14,
          marginTop: 8,
        }}
      >
        <span style={{ fontSize: 12, color: P.textMid, maxWidth: "45%", lineHeight: 1.4 }}>
          {leftLabel}
        </span>
        <span
          style={{
            fontSize: 12,
            color: P.textMid,
            maxWidth: "45%",
            textAlign: "right",
            lineHeight: 1.4,
          }}
        >
          {rightLabel}
        </span>
      </div>
    </div>
  );
}
